import { Controller } from "@hotwired/stimulus"

// Example Stimulus controller
// Usage: <div data-controller="hello" data-hello-name-value="World">
//          <span data-hello-target="output"></span>
//          <button data-action="click->hello#greet">Greet</button>
//        </div>

export default class extends Controller {
  static targets = ["output"]
  static values = { name: String }

  connect() {
    console.log("Hello controller connected")
  }

  greet() {
    this.outputTarget.textContent = `Hello, ${this.nameValue || "World"}!`
  }
}
